import { graphql } from "babel-plugin-relay/macro";

export const mutation = graphql`
    mutation csvUploadMutation($input: CsvUploadInput!) {
        csvUpload(input: $input) {
            result
        }
    }
`;
